import {network, users as typesUsers} from "../../../../../types";
import useQueryHookWrapper from "../../../../../hooks/use-query-hook-wrapper";
import {servicesUsers} from "../../../../../services";
import {QueryConfig} from "react-query/types/core/types";

const useUsersPaginationGet = (
  query: string = '',
  arg0?: QueryConfig<
    network.TQueryDefWrapper<typesUsers.TUsersResponse>,
    string
  >,
) => {
  return useQueryHookWrapper<
    network.TQueryDefWrapper<typesUsers.TUsersResponse>,
    string,
    { query: string}
  >({
    queryKey: 'users',
    queryFn: servicesUsers.get,
    queryConfig: arg0,
    values: { query: query }
  });
};

export default useUsersPaginationGet;
